/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
$('.toggle').click(function(e) {
  let $this = $(this);

  if ($this.next().hasClass('show')) {
    $this.next().removeClass('show');
    $this.next().slideUp(350);
  } else {
    $this.parent().parent().find('li .inner').removeClass('show');
    $this.parent().parent().find('li .inner').slideUp(350);
    $this.next().toggleClass('show');
    $this.next().slideToggle(350);
  }
});

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var isPrism = false, isDualPD = false, isAntiGlare = false, isAntiGlarePre = false;
var isConfirm = false, selectedTint;
var prescriptionOpt = '', chooseLense = '';
var productData;
var productJson;
var lenseTintJson = [], lenseUsageJson = [], lenseColorTypeJson = [], lenseTypeJson = [], lenseaddon, lenseaddon1;
var sphereRight = 'n/a', sphereLeft = 'n/a', cylinderRight = 'n/a', cylinderLeft = 'n/a', axisRight = 'n/a', axisLeft = 'n/a', addRight = 'n/a', addLeft = 'n/a', pdLeft = 'n/a', pdRight = 'n/a';
var verticleLeft = 'n/a', verticleRight = 'n/a', horizontalLeft = 'n/a', horizontalRight = 'n/a', baseLeft = 'n/a', baseRight = 'n/a', baseHLeft = 'n/a', baseHRight = 'n/a';
var selectVar;
var mainProductVar;
var cartJson = [];

if($('[data-template="product"]').length > 0){
  productData = JSON.parse($('[data-product-json]').html());
  productJson = productData.product;
  let adonJson = JSON.parse($('[data-lense-addon-json]').html()); 
  lenseaddon =  adonJson.variant;
  lenseaddon.tag = adonJson.product.tags;
  lenseaddon.product_handle = adonJson.product.handle;
  lenseaddon.product_title = adonJson.product.title;
  selectVar = $('#product-select-'+productJson.id).val();
  
  let adonJson1 = JSON.parse($('[data-lense-addon-1-json]').html()); 
  lenseaddon1 =  adonJson1.variant;
  lenseaddon1.tag = adonJson1.product.tags;
  lenseaddon1.product_handle = adonJson1.product.handle;
  lenseaddon1.product_title = adonJson1.product.title;
}


var lensPrescription = {
  init: function (){
    $('[data-lense-type-json]').each(function(){
      var variantData = JSON.parse($(this).html());
      var variant = variantData.variant;
      variant.tag = variantData.product.tags;
      variant.product_handle = variantData.product.handle;
      variant.product_title = variantData.product.title;
      lenseTypeJson.push(variant);
    });
    $('[data-lense-usage-json]').each(function(){
      var variantData = JSON.parse($(this).html());
      var variant = variantData.variant;
      variant.tag = variantData.product.tags; 
      variant.product_handle = variantData.product.handle;
      variant.product_title = variantData.product.title;
      lenseUsageJson.push(variant);
    });
    $('[data-lense-color-type-json]').each(function(){
      var variantData = JSON.parse($(this).html());
      var variant = variantData.variant;
      variant.tag = variantData.product.tags; 
      variant.product_handle = variantData.product.handle;
      variant.product_title = variantData.product.title;
      lenseColorTypeJson.push(variant);
    });
    $('[data-lense-tint-json]').each(function(){
      var variantData = JSON.parse($(this).html());
      var variant = variantData.variant;
      variant.tag = variantData.product.tags; 
      variant.product_handle = variantData.product.handle;
      variant.product_title = variantData.product.title;
      lenseTintJson.push(variant);
    });
    
    for(var i=0; i<productJson.variants.length; i++){
      if(productJson.variants[i].id == selectVar){
        mainProductVar = productJson.variants[i];
        mainProductVar.product_title = productJson.title;
      }
    }
  },
  
  chooseOption: function (el, type){
    prescriptionOpt = type;
    if(prescriptionOpt == 'usage-type-no-prescription'){
      $('[data-prescription-opt]').addClass('slide-hide');
      $('[data-lense-color-type]').removeClass('slide-hide');
    } else {
      $('[data-prescription-opt]').addClass('slide-hide');
      $('[data-your-prescription-wrap]').removeClass('slide-hide');
    }

    $('[data-your-prescription-wrap] select').each(function(){
      $(this).removeClass('border-danger');
    });

    if(prescriptionOpt == 'single-vision-reading' || prescriptionOpt == 'single-vision-distance'){
      $('[data-od-right-add]').addClass('disabledOp').prop("disabled", true);
      $('[data-os-left-add]').addClass('disabledOp').prop("disabled", true);
    } else {
      $('[data-od-right-add]').removeClass('disabledOp').prop("disabled", false);
      $('[data-os-left-add]').removeClass('disabledOp').prop("disabled", false);      
    }

    $('body').on('change', '[data-prism]', function(){
      var $el = $(this);
      if($el.is(':checked') == true){
        $('[data-add-prism-wrap]').removeClass('hide');
        isPrism = true;
      } else {
        $('[data-add-prism-wrap]').addClass('hide');
        isPrism = false;
      }	
    });

    $('body').on('change', '[data-dual-pd]', function(){
      var $el = $(this);
      if($el.is(':checked') == true){
        $('[data-left-pd]').removeClass('hide');
        $('[data-right-pd]').removeClass('hide');
        if($('[data-pd-opt]').hasClass('hide') != true){
          $('[data-pd-opt]').addClass('hide');
        }
        isDualPD = true;
      } else {
        $('[data-pd-opt]').removeClass('hide');
        if($('[data-left-pd]').hasClass('hide') != true && $('[data-right-pd]').hasClass('hide') != true){
          $('[data-left-pd]').addClass('hide');
          $('[data-right-pd]').addClass('hide');
        }
        isDualPD = false;
      }	
    });

  },
    
  confirmPrescription: function (el){
  	var $el = $(this);
    sphereRight = $('[data-your-prescription-wrap] [data-your-prescription] [data-od-right-sphere]').val();
    sphereLeft = $('[data-your-prescription-wrap] [data-your-prescription] [data-os-left-sphere]').val();
    cylinderRight = $('[data-your-prescription-wrap] [data-your-prescription] [data-od-right-cylinder]').val();
    cylinderLeft = $('[data-your-prescription-wrap] [data-your-prescription] [data-os-left-cylinder]').val();
    axisRight = $('[data-your-prescription-wrap] [data-your-prescription] [data-od-right-axis]').val();
    axisLeft = $('[data-your-prescription-wrap] [data-your-prescription] [data-os-left-axis]').val();
    addRight = $('[data-your-prescription-wrap] [data-your-prescription] [data-od-right-add]').val();
    addLeft = $('[data-your-prescription-wrap] [data-your-prescription] [data-os-left-add]').val();
    pdRight = $('[data-your-prescription-wrap] [data-your-prescription] [data-pd]').val();
     
    if(prescriptionOpt == 'bifocal' || prescriptionOpt == 'digital-progressive'){
      addRight = $('[data-your-prescription-wrap] [data-your-prescription] [data-od-right-add]').val();
      addLeft = $('[data-your-prescription-wrap] [data-your-prescription] [data-os-left-add]').val();
    }
    
      $('[data-your-prescription] [data-od-right-add]').removeClass('border-danger');
      $('[data-your-prescription] [data-os-left-add]').removeClass('border-danger');
      if(isPrism == true){        
        $('[data-add-prism-wrap] select').each(function(){
          if($(this).val() == 'n/a'){
          	isConfirm = false;
            $(this).addClass('border-danger');
          } else {
          	isConfirm = true;
            $(this).removeClass('border-danger');
          }
        });
        verticleLeft = $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-os-left-verticle]').val();
        verticleRight = $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-od-right-verticle]').val();
        horizontalLeft = $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-os-left-horizontal]').val();
        horizontalRight = $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-od-right-horizontal]').val();
        baseLeft = $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-os-left-verticle-base-direction]').val();
        baseRight = $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-od-right-verticle-base-direction]').val();
        baseHLeft =  $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-os-left-horizontal-base-direction]').val(); 
        baseHRight =  $('[data-your-prescription-wrap] [data-add-prism-wrap] [data-prism-od-right-horizontal-base-direction]').val();
      } 
    
      if(isDualPD == true){        
        $('[data-left-pd] select').removeClass('border-danger');
        $('[data-right-pd] select').removeClass('border-danger');
        
        if($('[data-left-pd] select').val() == 'n/a' && $('[data-right-pd] select').val() == 'n/a'){
          isConfirm = false;
          $('[data-left-pd] select').addClass('border-danger');
          $('[data-right-pd] select').addClass('border-danger');
        } else if($('[data-left-pd] select').val() != 'n/a' && $('[data-right-pd] select').val() == 'n/a'){          
          isConfirm = false;
          $('[data-right-pd] select').addClass('border-danger');
        } else if($('[data-left-pd] select').val() == 'n/a' && $('[data-right-pd] select').val() != 'n/a'){
          isConfirm = false;            
          $('[data-left-pd] select').addClass('border-danger');
        } else {
          pdLeft = $('[data-your-prescription-wrap] [data-your-prescription] [data-left-pd] select').val();
          pdRight = $('[data-your-prescription-wrap] [data-your-prescription] [data-right-pd] select').val();     
          isConfirm = true;
        }
      } 
    
    if(isPrism == false && isDualPD == false ){
      isConfirm = true;
    }
    
      if(prescriptionOpt == 'digital-progressive' || prescriptionOpt == 'bifocal'){
        lensPrescription.checkAdd();      
      }
    
    
    if(isConfirm == false){
    	return false;
    } else {
      $('[data-your-prescription-wrap]').addClass('slide-hide');
      $('[data-lense-color-type]').removeClass('slide-hide');
    }
  },
  
  chooseLense: function (el, type){
  	var $el = $(this);
    selectedTint = undefined;
    $('[data-lense-color-type]').addClass('slide-hide');
    $('[data-choose-lense]').removeClass('slide-hide');
    if(type == 'tint'){
      if($('[data-choose-lense] [data-clear-free]').hasClass('hide') == false){
        $('[data-choose-lense] [data-clear-free]').addClass('hide')
      }
      $('[data-choose-lense] [data-tint]').removeClass('hide');
    } else {
      if($('[data-choose-lense] [data-tint]').hasClass('hide') == false){
        $('[data-choose-lense] [data-tint]').addClass('hide')
      }
      $('[data-choose-lense] [data-clear-free]').removeClass('hide');
      if(prescriptionOpt != 'bifocal'){
        $('[data-choose-lense] [data-clear-free] [data-highest-167]').removeClass('hide');
      } else{
        if($('[data-choose-lense] [data-clear-free] [data-highest-167]').hasClass('hide') == false){
          $('[data-choose-lense] [data-clear-free] [data-highest-167]').addClass('hide');
        }
      }
      if(selectedTint != undefined){
         if($('[data-choose-lense] [data-clear-free] .accordion-container .add-on').hasClass('hide') == false){
        $('[data-choose-lense] [data-clear-free] .accordion-container .add-on').addClass('hide');
      } 
    } else {
      $('[data-choose-lense] [data-clear-free] .accordion-container .add-on').removeClass('hide');                    
    }
      if(prescriptionOpt == 'usage-type-no-prescription'){
        $('[data-choose-lense] [data-clear-free] [data-premium]').closest('label').addClass('hide');
      } else {
        $('[data-choose-lense] [data-clear-free] [data-premium]').closest('label').removeClass('hide');
      }
    }
    chooseLense = type;
  },
  
  chooseTint: function (el, type){
  	var $el = $(this);
    selectedTint = type;
    isAntiGlarePre = false;
    isAntiGlare = false;
    $('[data-choose-lense] [data-tint]').addClass('hide')
    $('[data-choose-lense] [data-clear-free]').removeClass('hide');
    if(prescriptionOpt != 'bifocal'){
    	$('[data-choose-lense] [data-clear-free] [data-highest-167]').removeClass('hide');
    } else{
      if($('[data-choose-lense] [data-clear-free] [data-highest-167]').hasClass('hide') == false){
      $('[data-choose-lense] [data-clear-free] [data-highest-167]').addClass('hide');
      }
    }
    
    if($('[data-choose-lense] [data-clear-free] .accordion-container .add-on').hasClass('hide') == false){
    $('[data-choose-lense] [data-clear-free] .accordion-container .add-on').addClass('hide');
    }
  },
  
  toggleAccordian: function (el, eventType){
    var $el = $(el);
    $('[data-choose-lense] [data-clear-free] .option').each(function(){
      if($(this).find('.main').attr('data-type') == eventType){
      	$(this).find('.accordion-container').toggleClass('collapse-hide');
      } else {
        if($(this).find('.accordion-container').hasClass('collapse-hide') != true){
        	$(this).find('.accordion-container').addClass('collapse-hide');
        }
      }
    });
  },
  
  toggleTintAccordian: function (el, eventType){
  	var $el = $(el);
    $('[data-choose-lense] [data-tint] .option').each(function(){
      if($(this).find('.main').attr('data-type') == eventType){
      	$(this).find('.tint-options').toggleClass('collapse-hide');
      } else {
        if($(this).find('.tint-options').hasClass('collapse-hide') != true){
        	$(this).find('.tint-options').addClass('collapse-hide');
        }
      }
    });
  },
  
  lenseType: function (el, eventType){
    var $el = $(el);
    var isChecked = $(this).is(':checked');
    
    $('[data-clear-free]').find('.accordion-container').each(function(){    
      if(eventType == 'premium'){
        isAntiGlarePre = true;
        isAntiGlare = false;
        $(this).find('[data-premium]').prop('checked', true);
        $(this).find('[data-yes]').prop('checked', false);
        $(this).find('[data-no]').prop('checked', false);
      }
      else if(eventType == 'yes'){
        isAntiGlare = true;
        isAntiGlarePre = false;
        $(this).find('[data-yes]').prop('checked', true);
        $(this).find('[data-no]').prop('checked', false);
        $(this).find('[data-premium]').prop('checked', false);
      }
      else {
        isAntiGlare = false;
        isAntiGlarePre = false;
        $(this).find('[data-no]').prop('checked', true);
        $(this).find('[data-yes]').prop('checked', false);
        $(this).find('[data-premium]').prop('checked', false);
      }
    });
   
  },
  
  checkAdd: function(){
    if($('[data-your-prescription] [data-od-right-add]').val() == 'n/a' && $('[data-your-prescription] [data-os-left-add]').val() == 'n/a'){
      isConfirm = false;
      $('[data-your-prescription] [data-od-right-add]').addClass('border-danger');
      $('[data-your-prescription] [data-os-left-add]').addClass('border-danger');
    } else if($('[data-your-prescription] [data-od-right-add]').val() != 'n/a' && $('[data-your-prescription] [data-os-left-add]').val() == 'n/a'){          
      isConfirm = false;
      $('[data-your-prescription] [data-os-left-add]').addClass('border-danger');
    } else if($('[data-your-prescription] [data-od-right-add]').val() == 'n/a' && $('[data-your-prescription] [data-os-left-add]').val() != 'n/a'){
      isConfirm = false;            
      $('[data-your-prescription] [data-od-right-add]').addClass('border-danger');
    } else {
      isConfirm = true;
    }
  },
  
  reviewSelection: function (el, eventType){
    var $el = $(el);
    $('[data-tab="4"]').addClass('slide-hide');
    $('[data-tab="5"]').removeClass('slide-hide');
    cartJson = [];
    let objM = mainProductVar;
    objM.lensetype = 'mainprod';
    cartJson.push(objM);
        
    if(isAntiGlare == true){
      let obj = lenseaddon;
      obj.lensetype = 'addon';
      cartJson.push(obj);
    } else if(isAntiGlarePre == true){
      let obj = lenseaddon1;
      obj.lensetype = 'addon';
      cartJson.push(obj);
    }
    
    for(var i=0; i<lenseUsageJson.length; i++){
      if(lenseUsageJson[i].product_handle == prescriptionOpt){
        let obj = lenseUsageJson[i];
        obj.lensetype = 'usage';
        cartJson.push(obj);
      }
    }
    
    for(var i=0; i<lenseColorTypeJson.length; i++){
      if(lenseColorTypeJson[i].product_handle == chooseLense){
        let obj = lenseColorTypeJson[i];
        obj.lensetype = 'color';
        cartJson.push(obj);
      }
    }    
    
    for(var i=0; i<lenseTypeJson.length; i++){
      if(lenseTypeJson[i].product_handle == eventType){
        let obj = lenseTypeJson[i];
        obj.lensetype = 'type';
        cartJson.push(obj);
      }
    }
    
    if(selectedTint != undefined){
      for(var i=0; i<lenseTintJson.length; i++){
        if(lenseTintJson[i].product_handle == selectedTint){
          let obj = lenseTintJson[i];
          obj.lensetype = 'tint';
          cartJson.push(obj);
        }
      }
    }
        
    var html = '';
    var mainHtml = '';
    var total = 000;
    for(var i=0; i<cartJson.length; i++){     
      var price = 'Free';
      total = parseInt(total + cartJson[i].price);
      if(cartJson[i].price != '000'){
      	price = Shopify.formatMoney(cartJson[i].price);
      }
      if(cartJson[i].lensetype == 'mainprod'){
      	mainHtml = '<dd class="line-item">'+cartJson[i].product_title+'<br>'+cartJson[i].title +' -  <span>'+price+'</span></dd>';
      } else {
      	html += '<dd class="line-item" data-title="'+cartJson[i].product_title+'">'+cartJson[i].product_title+' -  <span>'+price+'</span></dd>';
      }
    }
    
    if(prescriptionOpt == 'usage-type-no-prescription'){
    	$('[data-prescription-details]').addClass('hide');
    }
    
    if(prescriptionOpt != 'usage-type-no-prescription'){
      $('[data-prescription-details]').removeClass('hide');
      if($('[data-prism-details]').hasClass('hide') != true){
        $('[data-prism-details]').addClass('hide');
      }
      var odHtml = '<th>OD</th>'
      +'<td>'+sphereRight+'</td>'
      +'<td>'+cylinderRight+'</td>'
      +'<td>'+axisRight+'</td>'
      +'<td>'+addRight+'</td>'
      +'<td>'+pdRight+'</td>';
      var osHtml = '<th>OS</th>'
      +'<td>'+sphereLeft+'</td>'
      +'<td>'+cylinderLeft+'</td>'
      +'<td>'+axisLeft+'</td>'
      +'<td>'+addLeft+'</td>'
      +'<td>'+pdLeft+'</td>';
      
      $('[data-normal-details] [data-od]').html(odHtml);
      $('[data-normal-details] [data-os]').html(osHtml);
      
    }
    
    if(isPrism == true){
      $('[data-prism-detail]').removeClass('hide');
      var odHtml = '<th>OD</th>'
      +'<td>'+verticleRight+'</td>'
      +'<td>'+horizontalRight+'</td>'
      +'<td>'+baseRight+'</td>';
      var osHtml = '<th>OS</th>'
      +'<td>'+verticleLeft+'</td>'
      +'<td>'+horizontalLeft+'</td>'
      +'<td>'+baseLeft+'</td>';
      $('[data-prism-details] [data-od]').html(odHtml);
      $('[data-prism-details] [data-os]').html(osHtml);
      $('[data-prism-details]').removeClass('hide');
    }
    
    $('[data-main-details]').html(mainHtml);
    $('[data-order-details]').html(html);
    $('[data-total]').text(Shopify.formatMoney(total));
  },
  
  addtocart: function(el){
  	var $el = $(el);
    $('body').css('pointer-events','none');
    Shopify.queue = [];
    var propertiesJson =  {};
    var mainProd = '';
    
    for(var i=0;i< cartJson.length;i++){ 
      if(cartJson[i].lensetype == 'mainprod'){
      	 mainProd = cartJson[i].id;
      }
    }
    
    if(prescriptionOpt != 'usage-type-no-prescription') {
      propertiesJson = {
        "_OD Right Sphere" : sphereRight,
        "_OS Left Sphere" : sphereLeft,
        "_OD Right Cylinder" : cylinderRight,
        "_OS Left Cylinder" : cylinderLeft,
        "_OD Right Axis" : axisRight,
        "_OS Left Axis" : axisLeft,
        "_OD Right Add" : addRight,
        "_OS Left Add" : addLeft,
        "_OD Right PD" : pdRight,
        "_OS Left PD" : pdLeft,
        "Prescription type" : $('[data-order-details] [data-title]:first').data('title'),
        "Lens type" :  $('[data-order-details] [data-title]:last').data('title'),
        "Lens color" :  $('[data-order-details] [data-title]').eq(1).data('title'),
        "PD" : $('[data-pd-opt] select').val()
      };
      if(isPrism == true){
      	propertiesJson['_Prism OD Right Vertical'] = verticleRight;
        propertiesJson['_Prism OS Left Vertical'] = verticleLeft;
        propertiesJson['_Prism OD Right Vertical Base Direction'] = baseRight;
        propertiesJson['_Prism OS Left Vertical Base Direction'] = baseLeft;
        propertiesJson['_Prism OD Right Horizontal'] = horizontalRight;
        propertiesJson['_Prism OS Left Horizontal'] = horizontalLeft;
        propertiesJson['_Prism OD Right Horizontal Base Direction'] = baseHRight;
        propertiesJson['_Prism OS Left Horizontal Base Direction'] = baseHLeft;
      }
    } else {
      propertiesJson = {
        "Prescription type" : $('[data-order-details] [data-title]:first').data('title'),
        "Lens type" :  $('[data-order-details] [data-title]:last').data('title'),
        "Lens color" :  $('[data-order-details] [data-title]').eq(1).data('title')
      }
    }
    
    for(var i=0;i<cartJson.length;i++){
      let properties = {};
      if(mainProd == cartJson[i].id){
      	properties = propertiesJson;
        properties['_type'] = 'Frame';
      } else{
        properties['_type'] = cartJson[i].lensetype;
        properties['_parentProd'] = mainProd;      
      }

       let obj = {
        variantId: cartJson[i].id,
        quantity: 1,
        properties: properties
       };
           
      Shopify.queue.push(obj); 
    
    }
    
    console.log(Shopify.queue);
        
    Shopify.moveAlong = function() {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        var data = {
          id: request.variantId,
          quantity:1,
          properties: request.properties
        };
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: data,
          success: function(res){
            Shopify.moveAlong();
          },
          error: function(){              
            if (Shopify.queue.length){
              Shopify.moveAlong()
            }
          }
        });
      }
      else {
        $('body').css('pointer-events','auto');
        window.location.href="/cart";
      }
    };

    Shopify.moveAlong();
  },
  
  prevTab: function(current, prev){
    if(current == 3 && prescriptionOpt == 'usage-type-no-prescription'){
      $('[data-tab="'+current+'"]').addClass('slide-hide');
      $('[data-tab="1"]').removeClass('slide-hide');
    } else if(current == 5){
      $('[data-tab="'+current+'"]').addClass('slide-hide');
      $('[data-tab="'+prev+'"]').removeClass('slide-hide');
      $('[data-choose-lense] [data-clear-free]').removeClass('hide');
      if(prescriptionOpt != 'bifocal'){
        $('[data-choose-lense] [data-clear-free] [data-highest-167]').removeClass('hide');
      } else{
        if($('[data-choose-lense] [data-clear-free] [data-highest-167]').hasClass('hide') == false){
          $('[data-choose-lense] [data-clear-free] [data-highest-167]').addClass('hide');
        }
      }
      if(prescriptionOpt == 'usage-type-no-prescription'){
        $('[data-choose-lense] [data-clear-free] [data-premium]').closest('label').addClass('hide');
      } else {
        $('[data-choose-lense] [data-clear-free] [data-premium]').closest('label').removeClass('hide');
      }
    }
    else {
      $('[data-tab="'+current+'"]').addClass('slide-hide');
      $('[data-tab="'+prev+'"]').removeClass('slide-hide');
    }
  },
  
};


$(document).ready(function(){
  
  $('body').on('click', '[data-select-lense]', function(e){
  	e.preventDefault();
    selectVar = $('#product-select-'+productJson.id).val();
    var img, title;
    for(var i=0; i<productJson.variants.length; i++){
      if(productJson.variants[i].id == selectVar){
        if(productJson.variants[i].featured_image != null){
          img = productJson.variants[i].featured_image;
        } else {
          img = productJson.featured_image;
        }
        title = productJson.variants[i].title.split('(')[0];
      }
    }
    
    
    $('[data-product-img]').attr('src',img.src);
    $('[data-variant-title]').text(title);
    $('[data-lense-prescription-modal]').addClass('show');
    $('body').css('overflow-y','hidden');
  });

  $('body').on('click', '[data-close]', function(){
    $('[data-lense-prescription-modal]').removeClass('show');
    $('body').css('overflow-y','auto');
  });
  
  
  if($('[data-template="product"]').length > 0){
    lensPrescription.init();
  }


  $('body').on('click', '[data-remove-btn]', function(e){
    e.preventDefault();
    console.log('on click', $(this).closest('[data-cart-submit]').serializeArray());
    var prodID = $(this).attr('data-id');
    $('[data-cart-lists] [data-cart-prop="'+ prodID +'"] [data-qty]').val(0);
    $.ajax({
      type: 'POST', 
      url: '/cart/update.js',
      dataType: 'json', 
      data: $(this).closest('[data-cart-submit]').serialize(),
      success: function(data){
        //         console.log(data);
        location.reload();
      },
      error:  function(error){
        console.log(error);
      }
    });
  });
  
  $('[data-qty-btn]').on('click', function(e){
    e.stopPropagation();
    var prodID = $(this).attr('data-id');
    var qty = parseInt($(this).closest('.QuantitySelector').find('[data-qty]').val());
    if($(this).attr('data-type') == 'minus'){
//       if(qty > 1){
    	qty = qty - 1;
//       }
    } else {
    	qty = qty + 1;
    }
    $(this).closest('.QuantitySelector').find('[data-qty]').val(qty);
    $('.Cart__ItemList [data-cart-prop="'+ prodID +'"] [data-qty]').val(qty);
    console.log('on click', $(this).closest('[data-cart-submit]').serializeArray());
    $.ajax({
      type: 'POST', 
      url: '/cart/update.js',
      dataType: 'json', 
      data: $(this).closest('[data-cart-submit]').serialize(),
      success: function(data){
        //         console.log(data);
        location.reload();
      },
      error:  function(error){
        console.log(error);
      }
    });
  });
});


window.addEventListener('load',function(){
  var openSL = document.querySelector('#open-select-lense');
  var myModal = document.querySelector('#myModal');
  var closeModal = document.querySelector('.close');
  openSL.addEventListener('click',function(){
    myModal.classList.add('showModal');
  });
  closeModal.addEventListener('click',function(){
    myModal.classList.remove('showModal');
  });
});
